/*
 * TryAgainDialog Messages
 *
 * This contains all the text for the TryAgainDialog component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.TryAgainDialog";

export default defineMessages(scope, {
  removeMFA: "An error has occurred.",
  removeText: "Please click below to try again.",
});
